import { supabase } from '@/config/supabase'
import type { NotificacaoTemplate, UUID, PushMessage, PushDelivery } from '@/types/database'

export const notificacaoService = {
    // === Templates ===
    async listTemplates() {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_notificacao_templates')
            .select('*')
            .order('nome')

        if (error) throw error
        return (data || []) as unknown as NotificacaoTemplate[]
    },

    async createTemplate(input: Partial<NotificacaoTemplate>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_notificacao_templates')
            .insert(input as any)
            .select()
            .single()

        if (error) throw error
        return data as unknown as NotificacaoTemplate
    },

    async updateTemplate(id: UUID, input: Partial<NotificacaoTemplate>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_notificacao_templates')
            // @ts-ignore
            .update(input as any)
            .eq('id', id)
            .select()
            .single()

        if (error) throw error
        return data as unknown as NotificacaoTemplate
    },

    async removeTemplate(id: UUID) {
        const { error } = await supabase
            .schema('veicular_system')
            .from('veic_notificacao_templates')
            .delete()
            .eq('id', id)

        if (error) throw error
    },

    // === Messages & History ===
    async listMessages() {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_push_messages')
            .select('*')
            .order('created_at', { ascending: false })

        if (error) throw error
        return (data || []) as unknown as PushMessage[]
    },

    async getDeliveries(messageId: UUID) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_push_deliveries')
            .select('*, associado:veic_associados(nome)')
            .eq('message_id', messageId)

        if (error) throw error
        return (data || []) as unknown as (PushDelivery & { associado: { nome: string } })[]
    },

    // === Sending Logic ===
    async send(message: Partial<PushMessage>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_push_messages')
            .insert({
                titulo: message.titulo,
                corpo: (message as any).conteudo || (message as any).corpo, // Aceita as duas formas durante a transição
                tenant_id: message.tenant_id,
                status: 'enviado',
                enviado_at: new Date().toISOString()
            } as any)
            .select()
            .single()

        if (error) throw error
        return data as unknown as PushMessage
    }
}
